<nz-layout>
    <nz-content>
        <div class="application-landing__content">
            <nz-header class="application-landing__header flex-row justify-space-between">
                <div style="padding: 20px; flex: 1 1 0%" class="align-content-center">
                    <span class="application-landing__header__title"
                        ><span class="text--bold">PIDB</span> Code Recommender</span
                    >
                </div>
                <div>
                    <img src="assets/unicef_logo_for_background/unicef_logo_for_background.png" alt="Logo" />
                </div>
            </nz-header>
            <div class="application-landing__content__wrap">
                <div class="flex-row justify-center" style="padding-top: 35vh; flex: 1 1 0%">
                    <div class="flex-column justify-center align-content-center" style="gap: 50px">
                        <span class="text--bold welcome-text"
                            >This is an AI-powered app to recommend and/or quality assure selected PIDB codes.</span
                        >
                        <div class="flex-row justify-center p-t-15">
                            <button
                                class="get-started-button"
                                nz-button
                                nzSize="large"
                                nzType="primary"
                                (click)="getStarted()"
                                nzShape="round"
                            >
                                @if (!loader()) {
                                <span>Get started!</span>
                                } @if (loader()) {
                                <nz-spin nzSize="default" nzSimple></nz-spin>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
